import { jsx } from "react/jsx-runtime";
const DefaultShapeErrorFallback = function DefaultShapeErrorFallback2() {
  return /* @__PURE__ */ jsx("div", { className: "tl-shape-error-boundary" });
};
export {
  DefaultShapeErrorFallback
};
//# sourceMappingURL=DefaultShapeErrorFallback.mjs.map
